import queryString from 'query-string';
import spacetime from 'spacetime';
import { createHash } from 'crypto';
import { MED_PRODUCT_TRACKING_KEY } from '../../logic/meds-tracking';

export const QUERY_PARAMS = {
    IMPACT_CLICK_ID: 'irclickid',
    SNAP_CLICK_ID: 'ScCid',
    SNAP_CLICK_ID_2: 'sccid',
    FACEBOOK_CLICK_ID: 'fbclid',
    TIKTOK_CLICK_ID: 'ttclid',
    REDDIT_CLICK_ID: 'rdt_cid',
    X_CLICK_ID: 'twclid'
};

export const COOKIE_KEYS = {
    FACEBOOK_CLICK_ID: '_fbc',
    SNAP_CLICK_ID: 'ss_snapClickId',
    SNAP_COOKIE1: '_scid',
    IMPACT_CLICK_ID: 'irclickid',
    TIKTOK_CLICK_ID: 'ttclid',
    TIKTOK_COOKIE1: '_ttp',
    REDDIT_CLICK_ID: 'ss_redditClickId',
    REDDIT_COOKIE1: '_rdt_uuid',
    X_CLICK_ID: 'ss_xClickId'
};

export type UserData = {
    em: string,
    ph: string,
    fn: string,
    ln: string,
    ge: string,
    external_id: string,
    country: string,
    client_user_agent?: string
}

export type CustomDataDto = {
    currency?: string, // ISO 4217 currency code
    value?: number, // float
    content_ids?: string[],
    content_type?: string,
    lead_event_source?: string,
    product_line?: MED_PRODUCT_TRACKING_KEY, // base | micro | full
    funnel_id?: string
}

export const urlQueryParser = (path: string) => queryString.parse(path.split(/\?/)[1]);

export const normalizeEmail = (email?: string): string | undefined => {
    if (!email) return undefined;
    return email.toLowerCase().trim();
};

export const normalizePhone = (phone?: string): string | undefined => {
    if (!phone) return undefined;
    const digitsOnly = phone.replace(/\D/g, '');
    return digitsOnly || undefined;
};

export const normalizeName = (name?: string): string | undefined => {
    if (!name) return undefined;
    return name.toLowerCase().trim();
};

export const normalizeCountry = (country?: string): string | undefined => {
    if (!country) return undefined;
    return country.toLowerCase().trim();
};

export const normalizeGender = (gender?: string): string | undefined => {
    if (!gender) return undefined;
    switch (gender) {
    case 'Female':
        return 'f';
    case 'Male':
        return 'm';
    default:
        return undefined;
    }
};

export const normalizeDOB = (dob?: string): string | undefined => {
    if (!dob) return undefined;
    const spacetimeRefillDate = spacetime(dob);
    return spacetimeRefillDate?.format('iso-short')?.toString()?.replace(/-/g,'') || undefined;
};

export const sha256Hash = (data: string): string | undefined => {
    if (!data) return undefined;
    return createHash('sha256').update(data.toLowerCase().trim()).digest('hex');
};

export const getCurrentUrlPath = (): string | undefined => {
    if (typeof window === 'undefined') return undefined;
    return window.location.href;
};

export const getReferrerPath = (): string | undefined => {
    if (typeof window === 'undefined') return undefined;
    return window.document.referrer;
};
